import { Injectable, signal } from '@angular/core';

const CHUNK_RELOAD_KEY = 'chunk_reload_count';
const MAX_CHUNK_RELOADS = 3;

@Injectable({
  providedIn: 'root',
})
export class ChunkErrorService {
  readonly dialogVisible = signal(false);

  showRefreshDialog(): void {
    const reloadCount = parseInt(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0', 10);
    if (reloadCount >= MAX_CHUNK_RELOADS) {
      return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(reloadCount + 1));
    this.dialogVisible.set(true);
  }

  refresh(): void {
    const reload = () => window.location.reload();

    if (typeof caches !== 'undefined') {
      caches.keys().then(names => {
        Promise.all(names.map(name => caches.delete(name))).then(reload);
      });
    } else {
      reload();
    }
  }
}
